function emptyValueValidator(fieldName) {
  return {
    validate: 'regex_matches',
    regex: '^\\s*$',
    error: `Invalid, ${fieldName} is required`,
  }
}

export default emptyValueValidator
